import { usePage } from '@inertiajs/react'
import type { SharedProps, Permissions } from '@/frontend/types/inertia'

const DEFAULT_PERMISSIONS: Permissions = {
  can_access_forge: false,
  can_manage_organization: false,
  can_manage_resources: false,
  role: 'viewer',
  access_scope: 'organization',
}

export function usePermissions(): Permissions {
  const { permissions } = usePage<SharedProps>().props
  if (!permissions || !permissions.role) return DEFAULT_PERMISSIONS
  return permissions
}
